export const CLIENT_VIEW_KEY = 'clientViewAsSessionId';
export const CLIENT_VIEW_GLOBAL_KEY = 'clientViewAsActive';
export const CLIENT_VIEW_ERROR_EVENT = 'lvm-client-view-error';
export const clientViewSessionId = () => sessionStorage.getItem(CLIENT_VIEW_KEY) || localStorage.getItem(CLIENT_VIEW_GLOBAL_KEY) || '';
export const announceClientViewError = (message) => window.dispatchEvent(new CustomEvent(CLIENT_VIEW_ERROR_EVENT, { detail: message }));
export const rememberClientView = (view) => {
  sessionStorage.setItem(CLIENT_VIEW_KEY, view.sessionId);
  localStorage.setItem(CLIENT_VIEW_GLOBAL_KEY, view.sessionId);
  if (view.brandId && !sessionStorage.getItem('clientViewAsBrandId')) sessionStorage.setItem('clientViewAsBrandId', view.brandId);
};
export const clearClientView = () => {
  sessionStorage.removeItem(CLIENT_VIEW_KEY);
  sessionStorage.removeItem('clientViewAsBrandId');
  sessionStorage.removeItem('clientViewAsReturnTo');
  localStorage.removeItem(CLIENT_VIEW_GLOBAL_KEY);
};
// Only routes available to organisers can be carried into the client view.
export const clientViewDestination = (value = '') => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/admin';
  const path = value.split(/[?#]/)[0];
  if (path.startsWith('/admin/finance') || path === '/organiser/finance') return '/organiser/finance';
  if (['/admin', '/admin/events', '/admin/events/new', '/admin/brands', '/admin/orders', '/admin/reports', '/admin/promo-codes'].includes(path)) return path;
  if (/^\/admin\/(?:events|brands)\/[a-f0-9]{24}\/(?:edit|stats|analytics|embed|guest-list|waitlist|referrals|email|box-office)$/.test(path)) return path;
  return '/admin';
};

export const adminViewReturnPath = value => typeof value === 'string' && /^\/admin(?:\/[A-Za-z0-9-]+)*$/.test(value) ? value : '/admin';
